import { createStyles, CSSObject } from "@mantine/core";
import { tokens } from "@blurb/codex-react";

type SizeKey = keyof typeof tokens.font.size;
type WeightKey = keyof typeof tokens.font.weight;

const sizeClasses = Object.entries(tokens.font.size).reduce<Record<SizeKey, CSSObject>>(
  (remapped, [key, value]) => ({ ...remapped, [key]: { fontSize: value } }),
  {} as Record<SizeKey, CSSObject>
);

const weightClasses = Object.entries(tokens.font.weight).reduce<Record<WeightKey, CSSObject>>(
  (remapped, [key, value]) => ({ ...remapped, [key]: { "font-weight": value } }),
  {} as Record<WeightKey, CSSObject>
);

type TypographyTypes = "body" | "input" | "label" | "heading" | SizeKey | WeightKey;
export const useTypographyStyles = createStyles<TypographyTypes>(() => {
  const textType = {
    body: {
      fontFamily: tokens.font.family.sans,
      fontSize: tokens.font.size.base,
      "font-weight": tokens.font.weight.normal,
      lineHeight: tokens.font.lineHeight.snug,
    },
    input: {
      fontFamily: tokens.font.family.sans,
      fontSize: tokens.font.size.base,
      "font-weight": tokens.font.weight.normal,
      lineHeight: tokens.font.lineHeight.normal,
    },
    label: {
      fontFamily: tokens.font.family.sans,
      fontSize: tokens.font.size.base,
      "font-weight": tokens.font.weight.semibold,
      lineHeight: tokens.font.lineHeight.normal,
    },
    heading: {
      fontFamily: tokens.font.family.heading,
      fontSize: tokens.font.size.xl,
      "font-weight": tokens.font.weight.semibold,
      lineHeight: tokens.font.lineHeight.tight,
    },
    ...sizeClasses,
    ...weightClasses,
  };
  return textType;
});

export function useTextStyles() {
  const { classes, cx } = useTypographyStyles();

  const textClasses = (
    type: TypographyTypes = "body",
    size?: keyof typeof tokens.font.size,
    weight?: keyof typeof tokens.font.weight
  ) => cx(classes[type], size && classes[size], weight && classes[weight]);
  return textClasses;
}
